export enum HostNames {
  localhost = 'localhost',
  dyn = 'dyn-',
  cloud_j = 'prc-j.dev-ltl-xpo.com',
  cloud_g = 'prc-g.dev-ltl-xpo.com',
  cloud_s = 'prc-s.dev-ltl-xpo.com',
  cloud_prod = 'prc.ltl-xpo.com',
}
